import moment from 'moment/moment'

export default {
  methods: {
    // 場所や棚番の名前を表示させる
    mixinSpacesDisplay(id) {
      if (id && this.master.spaces) {
        const value = this.master.spaces.filter(item => item.id === id)
        return value.length ? value[0].name : ''
      }
      return null
    },
    // 在庫区分の名前を表示させる
    mixinInventoryKindDisplay(id) {
      if (id && this.master.inventoryKinds) {
        const value = this.master.inventoryKinds.filter(item => item.id === id)
        return value.length ? value[0].name : ''
      }
      return null
    },
    // 工程区分の名前を表示させる
    mixinProcessKindDisplay(id) {
      if (id && this.processKinds) {
        let proccessKindChildren = []
        this.processKinds.map((parentProcessKind)=>{
          proccessKindChildren = [...proccessKindChildren, ...parentProcessKind.datas]
        })
        const value = proccessKindChildren.filter(item => item.id === id)
        return value.length ? value[0].messageKey : ''
      }
      return null
    },
    // SpacesのList分け
    mixinSpacesListDisplay(key) {
      if (this.master.spaces) {
        const list = this.master.spaces.filter(item => item.key === key)
        return list
      }
      return null
    },
    // 品番や品名を表示させる
    mixinProductDisplay(id, key) {
      if (this.master.products && id) {
        const item = this.master.products.filter(item => item.id === id)
        const value = item[0][`${key}`]
        return value
      }
      return null
    },
    // 品番から品名を表示させる処理
    mixinGetProductName(value) {
      const name = this.master.products.filter(item => item.code === value)
      return name
    },
    // 配列の複数表示の処理
    mixinArrayKeyDisplay(list, array, key) {
      let res = []
      if (!array) return
      if (!this[list]) return
      if (!this[list].length) return
      if (!array.length) return
      const result = this[list].filter(item =>{
        let object = {}
        array.map(id => {
          if (item.id === id) object = item
        })
        if (object.id) return object
      })
      if (!result[0]) return
      result.map(item => {
        res.push(item[key])
      })
      return res.join(',')
    },
    // idから紐付けされるkeyの値を取得する処理
    mixinIdKeyDisplay(list, id, key) {
      if (!this[list] || !id) return ''
      if (!this[list].length) return ''
      const res = this[list].filter(item => item.id === id)
      if (!res[0]) return
      return res[0][key]
    },
    // idから紐付けされるオブジェクトを取得する処理
    mixinIdObjectDisplay(list, id) {
      if (!this[list] || !id) return {}
      if (!this[list].length) return {}
      const res = this[list].filter(item => item.id === id)
      if (!res[0]) return {}
      return res[0]
    },
    // valueから権限名を取得する
    mixinPrivilegeDisplay(value) {
      if (this.master.company) {
        const obj = this.master.company.privilege
        const key = Object.keys(obj).filter(key => {
 return obj[key] == value
})
        if (key.length) {
          return this.$t(key[0])
        }
      }
      return null
    },
    // 時間の単位を表示
    mixinTimeUnitDisplay(value) {
      switch (value) {
        case 'sec':
          return this.$t('秒')
        case 'min':
          return this.$t('分')
        case 'hour':
          return this.$t('時間')
        case 'day':
          return this.$t('日')
        default:
          return ''
      }
    },
  },
  filters: {
    mixinRemainDay: (date) => {
      if (date && (typeof date) === 'number') {
        const abs = Math.abs(date)
        return abs
      } else {
        return ''
      }
    },
    // 数字にコンマをつける
    mixinCommaDisplay: (num) => {
      if ((typeof num) === 'number') {
        return num.toLocaleString()
      } else if ((typeof num) === 'string') {
        return Number(num).toLocaleString()
      }
    },
    mixinNumberFormatDisplay: (num) => {
      if (!num) {
 return
}
      return num.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,')
    },
    // yyyy-MM-dd から yyyy/MM/dd に変換する
    mixinDateFormatChange: (dateString) => {
      if (dateString) {
        const changeDate = dateString.replace(/-/g, '/')
        return changeDate
      } else {
        return ''
      }
    },
    // yyyy-MM-dd から 'yy/MM/dd に変換する
    mixinDateShortFormat: (dateString) => {
      if (dateString) {
        return moment(dateString, 'YYYY-MM-DD').format('\'YY/MM/DD')
      } else {
        return ''
      }
    },
    mixinViewTimeToHourMinute: (time) => {
      if (time) {
        let time_tmp = time.toString().split(':')
        time_tmp.pop()
        return time_tmp.join(':')
      } else {
        return ''
      }
    },
  },
}
